






















































































































































































import { Component, Vue } from "vue-property-decorator";
import { storeCpCompliance } from "@/store/modules/CpComplianceStore";

@Component
export default class CpComplianceDashboard extends Vue {
  storeModule = storeCpCompliance;

  get dash() {
    return this.storeModule.dashboard || {};
  }

  get statusColor() {
    const capaian = this.dash.capaian_persen || 0;
    return capaian >= 80 ? "green--text" : "red--text";
  }

  mounted() {
    this.storeModule.loadDashboard();
  }
}
